const fb = require("../firebase.js");

export default {
  namespaced: true,
  state: {
    activities: [],
    activitiesPending: false,
    activitiesError: null,

    lastDoc: null
  },
  mutations: {
    // activities
    pushActivities (state, value) {
      state.activities.push(...value)
    },
    setActivitiesPending (state, value) {
      state.activitiesPending = value
    },
    setActivitiesError (state, value) {
      state.activitiesError = value
    },
    // last doc
    setLastDoc (state, value) {
      state.lastDoc = value
    },
  },
  actions: {
    async getFirstActivities({ state, commit, dispatch }){
      if(state.activities.length > 0) return
      console.log("getFirstActivities")
      commit('setActivitiesPending', true)
      let querySnapshot = await fb.db.collection("activities").orderBy("createdAt", "desc").limit(6).get()
      dispatch("getActivities", querySnapshot)
    },
    async getNextActivities({ state, commit, dispatch }){
      commit('setActivitiesPending', true)
      console.log("getNextActivities")
      let querySnapshot = await fb.db.collection("activities").orderBy("createdAt", "desc").limit(6).startAfter(state.lastDoc || 0).get()
      dispatch("getActivities", querySnapshot)
    },
    getActivities({commit}, querySnapshot){
      commit('setLastDoc', querySnapshot.docs[querySnapshot.docs.length - 1])
      if(querySnapshot.empty) commit('setActivitiesPending', false)
      let refs = []
      querySnapshot.forEach((doc) => {
        refs.push(doc.data().ref.path)
      })
      refs = refs.map(ref => fb.db.doc(ref).get())
      Promise.all(refs).then((values) => {
        let activities = []
        values.forEach((doc) => {
          activities.push({ id: doc.id, ...doc.data() })
        });
        commit('pushActivities', activities)
      }).catch((error) => {
        commit('setActivitiesError', error)
        commit('setActivitiesPending', false)
      });
    },   
  }
}
  